import React from "react";
import { SeoMeta } from "../components/SeoMeta";
import { Card, CardContent } from "../components/ui/card";
import { UserRound } from "lucide-react";
import { TEAM } from "../mock";

export default function Team() {
  return (
    <div className="relative">
      <SeoMeta 
        title="Náš tým | Zdravé packy Nový Bohumín"
        description="Poznejte náš tým certifikovaných fyzioterapeutek zvířat v Novém Bohumíně. Odborná a láskyplná péče o vaše čtyřnohé parťáky."
        url="https://www.zdravepacky.cz/team"
      />
      <section className="pt-10 pb-16">
        <div className="mx-auto max-w-4xl px-4">
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-foreground">
            Náš tým
          </h1>
          <p className="text-muted-foreground mt-2">
            Poznejte náš tým fyzioterapeutek, které se starají o zdraví a regeneraci vašich mazlíčků.
          </p>

          <div className="grid sm:grid-cols-2 gap-8 mt-8">
            {TEAM.map((member) => (
              <Card 
                key={member.id} 
                className="bg-white/10 backdrop-blur-xl border-white/20 overflow-hidden flex flex-col card-hover shadow-sm"
              >
                <div className="relative h-72 sm:h-80 w-full overflow-hidden bg-muted/20 flex items-center justify-center border-b border-white/10">
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name} 
                      className="w-full h-full object-cover object-top" 
                    />
                  ) : (
                    <div className="flex flex-col items-center justify-center gap-2 p-6 text-center text-muted-foreground">
                      <div className="w-16 h-16 rounded-full bg-white/10 dark:bg-white/5 border border-white/20 flex items-center justify-center text-muted-foreground/70">
                        <UserRound className="w-8 h-8" />
                      </div>
                      <span className="text-xs font-medium">Bude doplněna fotografie</span>
                    </div>
                  )}
                </div>

                <CardContent className="p-6 flex flex-col flex-1">
                  <h2 className="text-xl font-semibold text-foreground">
                    {member.name}
                  </h2>
                  {member.role && (
                    <p className="text-sm font-medium text-blue-700/90 dark:text-blue-300 mt-1 leading-snug">
                      {member.role}
                    </p>
                  )}

                  {member.bio && (
                    <p className="mt-4 text-sm text-foreground/80 leading-relaxed whitespace-pre-line">
                      {member.bio}
                    </p>
                  )}

                  {member.details && member.details.length > 0 && (
                    <div className="mt-auto pt-5">
                      <p className="text-xs font-semibold text-foreground/90 uppercase tracking-wider mb-2">
                        Vzdělání a praxe:
                      </p>
                      <ul className="grid gap-1 text-sm list-disc pl-5 text-foreground/80">
                        {member.details.map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
